module.exports = __webpack_public_path__ + "img/vehicle_pin.2cdbc4b0.svg";